<template>
    <div class="content-pc">
        <div
            class="title mg-title"
            v-if="recentListingTitle"
            v-html="recentListingTitle"
        ></div>
        <rencentListingsPc />
    </div>
</template>

<script>
import rencentListingsPc from '../recent-listings/pc';
export default {
    name: 'content-pc',
    components: {
        rencentListingsPc: rencentListingsPc
    },
    props: {
        recentListingTitle: {
            required: true,
            type: String
        }
    }
};
</script>

<style lang="scss">
.md-listing-list .content-pc .title {
    padding-bottom: 0;
    margin-left: 0;
    margin-right: 0;
}
</style>
